import Head from "next/head";
import React from "react";

type HeadMetaTagProps = {
  title?: string;
};
export default function HeadMetaTag({
  title = "Jobbi - Find your next job",
}: HeadMetaTagProps) {
  return (
    <Head>
      <title>{title}</title>
      <meta
        name="description"
        content="Connect with job opportunities easily on Jobbi. Apply, search, and find your ideal job."
      />
      <link rel="icon" href="/favicon.ico" />
    </Head>
  );
}
